module.exports = __webpack_public_path__ + "img/ball_cont_good.9d3b65d1.svg";